var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tag',{attrs:{"type":_vm.type,"closable":_vm.closable,"disable-transitions":_vm.disableTransitions,"hit":_vm.hit,"color":_vm.color,"size":_vm.size,"effect":_vm.effect}},[_vm._v(" "+_vm._s(_vm.values)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }